import { render, staticRenderFns } from "./StudyPage.vue?vue&type=template&id=2b7cb3fd&class=study-page&"
import script from "./StudyPage.vue?vue&type=script&lang=ts&"
export * from "./StudyPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports